export interface UrlHashInterface {
  schoolId: number
  activityId: number
  hash: string
  /**
   * 主键 ID
   */
  id: number
}

export class UrlHash implements UrlHashInterface {
  schoolId: number
  activityId: number
  hash: string
  /**
   * 主键 ID
   */
  id: number

  constructor(props: UrlHashInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      schoolId: _schoolId,
      activityId: _activityId,
      hash: _hash,
      id: _id,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.schoolId = _schoolId
    this.activityId = _activityId
    this.hash = _hash
    this.id = _id
  }
}
